import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {BrowserRouter as Router} from 'react-router-dom';

// Redux 관련 불러오기
import { Provider } from 'react-redux';
import store from './store/index';
const render = () => {
    ReactDOM.render(
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>,
        document.getElementById('root')
    );
};
store.subscribe(render);
render();